import React from "react";
import FooterLogo from "./FooterLogo";
import FooterLinks from "./FooterLinks";
import CTA from "./CTA";
import Copyright from "./Copyright";
const Footer = () => {
  return (
    <>
      <FooterLogo />
      <FooterLinks />
      <CTA />
      <Copyright />
    </>
  );
};

export default Footer;
